import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-item',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './search-item.component.html',
  styleUrl: './search-item.component.scss'
})
export class SearchItemComponent {
  constructor() {}

  public active: boolean = false;
  @Input() className: any = '';
  @Output() searchItem: EventEmitter<any> = new EventEmitter<string>();

  searchInput: any = '';

  setActive() {
    this.active = true;
    if (this.searchInput !== '') this.searchItem.emit(this.searchInput);
  }

  close = () => {
    this.active = false;
    this.searchInput = '';
  };
}
